import React from 'react';
import { ReactComponent as ArticleIcon } from '@assets/icons/content/article.svg';
import { ReactComponent as SeriesIcon } from '@assets/icons/content/series.svg';
import { ReactComponent as SurveyIcon } from '@assets/icons/content/survey.svg';
import { ReactComponent as VideoIcon } from '@assets/icons/content/video-content.svg';
import { ReactComponent as ResourceIcon } from '@assets/icons/content/resources.svg';
import { ContentTypes } from '@data/contents/Contents.model';

export const getContentTypeView = (contentType?: ContentTypes) => {
  switch (contentType) {
    case ContentTypes.ARTICLE:
      return {
        value: ContentTypes.ARTICLE,
        label: 'Article',
        icon: (className?: string) => <ArticleIcon className={className} />,
        description: 'A template for text focused content.',
        active: true,
      };
    case ContentTypes.SERIES:
      return {
        value: ContentTypes.SERIES,
        label: 'Series',
        icon: (className?: string) => <SeriesIcon className={className} />,
        description: 'Multiple content in one.',
        active: true,
      };
    // case ContentTypes.AUDIO:
    //   return {
    //     value: ContentTypes.AUDIO,
    //     label: 'Audio',
    //     icon: (className?: string) => <AudioIcon className={className} />,
    //     description: 'Podcast compatible.',
    //     active: false,
    //   };
    // case ContentTypes.POLL:
    //   return {
    //     value: ContentTypes.POLL,
    //     label: 'Poll',
    //     icon: (className?: string) => <PollIcon className={className} />,
    //     description: 'A single question.',
    //     active: false,
    //   };
    //
    case ContentTypes.QUIZ:
      return {
        value: ContentTypes.QUIZ,
        label: 'Quiz',
        icon: (className?: string) => <SurveyIcon className={className} />,
        description: ' A series of questions.',
        active: true,
      };
    case ContentTypes.VIDEO:
      return {
        value: ContentTypes.VIDEO,
        label: 'Video',
        icon: (className?: string) => <VideoIcon className={className} />,
        description: 'A template for video-focused content.',
        active: false,
      };
    case ContentTypes.RESOURCE:
      return {
        value: ContentTypes.RESOURCE,
        label: 'Resource',
        icon: (className?: string) => <ResourceIcon className={className} />,
        description: 'A downloadable or external resource.',
        active: false,
      };
    default:
      return {
        value: ContentTypes.UNKNOWN,
        label: 'Unknown',
        icon: (className?: string) => null,
      };
  }
};
